module.exports = __webpack_public_path__ + "img/premium-dashboard-sm.a4ed252a.svg";